// extracted by mini-css-extract-plugin
export var chevron = "_jw-4";
export var chevronExpanded = "_jw-5";
export var row = "_jw-0";
export var rowBody = "_jw-6";
export var rowDescription = "_jw-7";
export var rowHeader = "_jw-1";
export var rowTitle = "_jw-2";
export var rowTitleComplete = "_jw-3";